type ExportListener = () => void;

const exportPromises = new Map<string, Promise<unknown>>();
const listeners = new Map<string, Set<ExportListener>>();

const notify = (key: string) => {
    listeners.get(key)?.forEach((listener) => listener());
};

export const isExportInProgress = (key: string) => exportPromises.has(key);

export const subscribeToExportStatus = (key: string, listener: ExportListener) => {
    const keyListeners = listeners.get(key) || new Set<ExportListener>();
    keyListeners.add(listener);
    listeners.set(key, keyListeners);

    return () => {
        keyListeners.delete(listener);
        if (!keyListeners.size) {
            listeners.delete(key);
        }
    };
};

export const runTrackedExport = async (key: string, exportTask: () => Promise<unknown>) => {
    const currentExport = exportPromises.get(key);
    if (currentExport) {
        return currentExport;
    }

    const exportPromise = exportTask().finally(() => {
        if (exportPromises.get(key) === exportPromise) {
            exportPromises.delete(key);
            notify(key);
        }
    });

    exportPromises.set(key, exportPromise);
    notify(key);

    return exportPromise;
};
